import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// Auto-recover from stale lazy-chunk failures after a new deploy.
// "Importing a module script failed" usually means the user has an old
// HTML bundle pointing at hashed chunks that no longer exist.
const reloadOnChunkError = (msg?: string) => {
  if (!msg) return;
  const stale = /Importing a module script failed|Failed to fetch dynamically imported module|ChunkLoadError/i.test(msg);
  if (!stale) return;
  const key = "__chunkReloadAt";
  const last = Number(sessionStorage.getItem(key) || 0);
  // Avoid reload loops — only auto-reload once per 30s.
  if (Date.now() - last < 30_000) return;
  sessionStorage.setItem(key, String(Date.now()));
  window.location.reload();
};

window.addEventListener("error", (e) => reloadOnChunkError(e?.message));
window.addEventListener("unhandledrejection", (e) => reloadOnChunkError(String(e?.reason?.message || e?.reason)));

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
